import HeroSection from './HeroSection/HeroSection';
import React from 'react';

function KnowYourRights() {
  return (
    <React.Fragment>
      <div style={{ marginTop: '66px' }}>
        <HeroSection
          title="Conoce tus derechos"
          description="Home / Conoce tus derechos"
          heroImage="/images/know-your-rights/know-your-rights-banner.jpg"
          height="40vh"
        />
      </div>
      <div className="know-your-rights content-container  font11">
        <div className="pullman-section-primary-row">
          <div className="pullman-section-primary-row-main-heading black-text margin-T30">
            Conoce tus derechos
          </div>
          <div className="pullman-section-primary-row-underline margin-B35"></div>
        </div>
        <div className="know-your-rights__row">
          <strong>Deberes de los pasajeros:</strong>
        </div>
        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>{' '}
          <p>Planifique su viaje y compre sus pasajes con la debida anticipación.</p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Compre los pasajes solo en las líneas y las empresas del comercio establecido para así
            estar adecuadamente protegido frente a posibles problemas. El transporte ilegal o pirata
            no entrega ninguna garantía de respeto a los derechos como consumidor.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Confirme la validez de las promociones u ofertas que puedan disponer las empresas en sus
            viajes. Revise folletos (si los hay), pregunte al vendedor de pasajes (en las cajas de
            los terminales de buses o centros de venta) o revise el sitio Web de cada empresa, si
            esta lo posee.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Exija un comprobante por cada bulto de equipaje que lleve en las cámaras portaequipajes.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Tenga precaución con su equipaje de mano, es de su entera responsabilidad lo que lleve
            al interior del bus.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Declare al llevar equipaje cuyo valor exceda a las 5 Unidades Tributarias Mensuales
            ($160.000 aproximados) en los formularios habilitados por cada empresa. Si no lo hace,
            se expone a que ante la pérdida de su equipaje, la empresa sólo responda hasta 5 UTM y
            no por el verdadero valor del bien que extravió.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Exija que el bus donde viaja lleve un dispositivo acústico y luminoso de color rojo al
            interior del vehículo, el cual debe estar a la vista de los pasajeros y activarse
            automáticamente cada vez que la velocidad del bus exceda de 100 kilómetros por hora.
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p> Exija al conductor bajar la velocidad cuando el dispositivo esté encendido.</p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p> Exija que el volumen del audio (radio o tv) se mantenga en un nivel adecuado.</p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Es también su deber mantener en buen estado el mobiliario de la unidad que lo
            transporta, no debe rayar o destruir asientos, vidrios y cortinas del bus, tampoco pegar
            chicles u otros de carácter adhesivo. El baño debe ser usado solo para orinar, teniendo
            en consideración que lo utilizarán también otros pasajeros. Está prohibido a los
            pasajeros fumar y beber alcohol dentro del bus.
          </p>
        </div>

        <div className="know-your-rights__row__sub mb-20">
          <span className="know-your-rights__dot"></span>
          <p>
            {' '}
            Ponga por escrito sus comentarios en el libro de reclamos de la empresa ante
            incumplimientos de los servicios ofrecidos.
          </p>
        </div>

        <div className="know-your-rights__row">
          <p>
            <strong>OTRAS DIRECCIONES DE INTERÉS RESPECTO A ESTE TEMA</strong>
          </p>
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Ley del Consumidor:
          <a className="know-your-rights__row__links" href="#">
            https://www.leychile.cl/Navegar?idNorma=61438
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Reglamento de los Servicios Nacionales de
          Transporte Público de Pasajeros D.S 212/92:{' '}
          <a className="know-your-rights__row__links" href="#">
            http://www.subtrans.cl/subtrans/doc/leyes_ds212_1992(agosto2005).pdf
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Fiscalización de Transportes:
          <a className="know-your-rights__row__links" href="#">
            {' '}
            http://www.fiscalizacion.cl/
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Ministerio de Transportes:
          <a className="know-your-rights__row__links" href="#">
            {' '}
            http://www.mtt.cl
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Subsecretaría de Transportes:
          <a className="know-your-rights__row__links" href="#">
            {' '}
            http://www.subtrans.cl
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub">
          <span className="know-your-rights__dot"></span> Servicio Nacional del Consumidor Sernac:
          <a className="know-your-rights__row__links" href="#">
            {' '}
            http://www.sernac.cl.
          </a>
          .
        </div>

        <div className="know-your-rights__row__sub mb-20">
          <span className="know-your-rights__dot"></span> Fenabus:
          <a className="know-your-rights__row__links" href="#">
            {' '}
            http://fenabuschile.cl/sitio/
          </a>
          .
        </div>
      </div>
    </React.Fragment>
  );
}

export default KnowYourRights;



// WEBPACK FOOTER //
// ./src/features/pages/KnowYourRights.js